var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackward2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    y: 0.499756,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#F1F1F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_14835",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 45,
    height: 45
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    y: 0.499756,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_14835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6948 12.3659C24.5319 12.3024 24.3544 12.2863 24.1827 12.3195C24.0111 12.3526 23.8523 12.4337 23.7248 12.5533L14.9064 21.3717C14.7408 21.5389 14.6479 21.7647 14.6479 22C14.6479 22.2353 14.7408 22.4611 14.9064 22.6283L23.7248 31.4467C23.8941 31.6085 24.1189 31.6992 24.3531 31.7002C24.4701 31.6997 24.586 31.6772 24.6948 31.6341C24.8553 31.5666 24.9922 31.4531 25.0884 31.308C25.1845 31.1628 25.2355 30.9925 25.2349 30.8184V13.1816C25.2355 13.0075 25.1845 12.8372 25.0884 12.692C24.9922 12.5469 24.8553 12.4334 24.6948 12.3659Z",
    fill: "#0D3875"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward2);
export default __webpack_public_path__ + "static/media/backward2.6dbbe616e1a3761a081e8a609f6ea5d4.svg";
export { ForwardRef as ReactComponent };